import { render } from "./Testimonials.vue?vue&type=template&id=579a9fad"
import script from "./Testimonials.vue?vue&type=script&lang=js"
export * from "./Testimonials.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Keith\\source\\michaelslyfescheme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__